// ProtectedRoute.js
import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { auth } from './firebase';

const ProtectedRoute = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => auth.onAuthStateChanged(async (user) => {
        try {
            setIsAuthenticated(!!user && (await user.getIdTokenResult()).claims.admin === true);
        } catch (_) {
            setIsAuthenticated(false);
        } finally {
            setLoading(false);
        }
    }), []);

    // 로딩 중
    if (loading) {
        return (
            <div className="min-h-screen bg-gray-50 flex items-center justify-center">
                <div className="text-center">
                    <div className="text-4xl mb-4">⏳</div>
                    <div className="text-xl font-bold text-gray-800">인증 확인 중...</div>
                </div>
            </div>
        );
    }

    // 인증되지 않은 경우 로그인 페이지로 리다이렉트 - woogi-login으로 변경
    if (!isAuthenticated) {
        return <Navigate to="/woogi-login" replace />;
    }

    // 인증된 경우 - 자식 컴포넌트만 렌더링
    return children;
};

export default ProtectedRoute;
